import { useEffect } from 'react';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import './style.less';

export type TimelineProps = CommonPropsWithChildren;

/**
 * @deprecated 请使用Timeline2组件替换
 */
export const Timeline = (props: TimelineProps) => {
  useEffect(() => {
    console.warn('@flatbiz/react库【Timeline】组件即将废弃，请使用【Timeline2】组件替代');
  }, []);

  return withNativeProps(props, <div className="v-timeline">{props.children}</div>);
};
